import {EvrakTuru} from "./store/modules/TaskDataInterface/EvrakGonderTaskDataInterface";

export class MDB {
    digerTalepler: any = [
        {
            "grupKodu": 2,
            "talepKodu": 38,
            "talepAdi": "Dosya Yenileme Talebi",
            "talepKisaAdi": "Dosya Yenileme Talebi",
            "talepMasrafi": 0,
            "className": "AvukatTalepDosyaYenilemeDvo",
            "postaMasrafId": 0,
            "dosyaDurum": "K"
        },
        {

        "grupKodu": 2,
        "talepKodu": 13,
        "talepAdi": "Dosya Hesabının Yapılması ve Dosyaya Kaydedilmesi",
        "talepKisaAdi": "Dosya Hesabının Yapılması ve Dosyaya Kaydedilmesi",
        "talepMasrafi": 0,
        "className": "AvukatTalepGenelDosyaHesabiDVO",
        "postaMasrafId": 0,
        "dosyaDurum": "H"
    },
        {
            "grupKodu": 2,
            "talepKodu": 14,
            "talepAdi": "Borçlu Tarafından Yapılan Ödemelerin Hesaba Aktarılması",
            "talepKisaAdi": "Borçlu Tarafından Yapılan Ödemelerin Hesaba Aktarılması",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelOdemeAktarDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "H"
        },
        {
            "grupKodu": 2,
            "talepKodu": 15,
            "talepAdi": "Dosyadaki IBAN Bilgisinin Güncellenmesi",
            "talepKisaAdi": "Dosyadaki IBAN Bilgisinin Güncellenmesi",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelIbanGuncelleDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "H"
        },
        {
            "grupKodu": 2,
            "talepKodu": 16,
            "talepAdi": "Araç Üzerindeki Yakalama Şerhinin Kaldırılması",
            "talepKisaAdi": "Araç Üzerindeki Yakalama Şerhinin Kaldırılması",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelAracYakalamaKaldirDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "H"
        },
        {
            "grupKodu": 2,
            "talepKodu": 17,
            "talepAdi": "Araç Üzerindeki Haciz Şerhinin Kaldırılması",
            "talepKisaAdi": "Araç Üzerindeki Haciz Şerhinin Kaldırılması",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelAracHacziKaldirDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "H"
        },
        {
            "grupKodu": 2,
            "talepKodu": 18,
            "talepAdi": "Maaş Üzerindeki Hacizlerin Kaldırılması",
            "talepKisaAdi": "Maaş Üzerindeki Hacizlerin Kaldırılması",
            "talepMasrafi": 175,
            "className": "AvukatTalepGenelMaasHacziKaldirDVO",
            "postaMasrafId": 1536,
            "dosyaDurum": "H"
        },
        {
            "grupKodu": 2,
            "talepKodu": 19,
            "talepAdi": "Taşınmaz Haczinin Kaldırılması",
            "talepKisaAdi": "Taşınmaz Haczinin Kaldırılması",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelTasinmazHacziKaldirDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "H"
        },
        {
            "grupKodu": 2,
            "talepKodu": 20,
            "talepAdi": "Hacizli Taşınır Malların Muhafaza Altına Alınması",
            "talepKisaAdi": "Hacizli Taşınır Malların Muhafaza Altına Alınması",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelTasinirMuhafazaDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 2,
            "talepKodu": 21,
            "talepAdi": "Dosyadaki Hacizlerin Kaldırılması",
            "talepKisaAdi": "Dosyadaki Hacizlerin Kaldırılması",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelTumHacziKaldirDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "H"
        },
        {
            "grupKodu": 2,
            "talepKodu": 22,
            "talepAdi": "Muhafaza Altındaki Malların Haciz Baki Kalarak Yeddiemin Değişikliği",
            "talepKisaAdi": "Muhafaza Altındaki Malların Haciz Baki Kalarak Yeddiemin Değişikliği",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelYeddiEminDegisikligiDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 2,
            "talepKodu": 25,
            "talepAdi": "Dosyanın Yetkili İcra Dairesine Gönderilmesi",
            "talepKisaAdi": "Dosyanın Yetkili İcra Dairesine Gönderilmesi",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelYetkiliIcraDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "H"
        },
        {
            "grupKodu": 2,
            "talepKodu": 26,
            "talepAdi": "Dosyanın İşlemden Kaldırılması",
            "talepKisaAdi": "Dosyanın İşlemden Kaldırılması",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelDosyaKapatDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 2,
            "talepKodu": 27,
            "talepAdi": "Dosyada Hacizli Malın Satışı",
            "talepKisaAdi": "Dosyada Hacizli Malın Satışı",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelSatisTalebiDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 2,
            "talepKodu": 28,
            "talepAdi": "Kıymet Takdirinin Yapılması",
            "talepKisaAdi": "Kıymet Takdirinin Yapılması",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelKiymetTakdiriDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 2,
            "talepKodu": 29,
            "talepAdi": "Hacizli Malın Satışı için Talimat Yazılması",
            "talepKisaAdi": "Hacizli Malın Satışı için Talimat Yazılması",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelSatisicinTalimatDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 2,
            "talepKodu": 30,
            "talepAdi": "Hacizli Malın Kıymet Takdiri için Talimat Yazılması",
            "talepKisaAdi": "Hacizli Malın Kıymet Takdiri için Talimat Yazılması",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelKiymetTakdiricinTalimatDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 2,
            "talepKodu": 31,
            "talepAdi": "Takibin Kesinleşmesi",
            "talepKisaAdi": "Takibin Kesinleşmesi",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelTakibiKesinlestirDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 2,
            "talepKodu": 32,
            "talepAdi": "Aciz Belgesi Hazırlanması",
            "talepKisaAdi": "Aciz Belgesi Hazırlanması",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelAcizBelgesiDvo",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 2,
            "talepKodu": 33,
            "talepAdi": "İİK.150/C Şerhi Eklenmesi",
            "talepKisaAdi": "İİK.150/C Şerhi Eklenmesi",
            "talepMasrafi": 2.5,
            "className": "AvukatTalepGenelIIk150CSerhiEkleDvo",
            "postaMasrafId": 4864,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 2,
            "talepKodu": 34,
            "talepAdi": "İİK.121. Maddeye Göre Yetki Verilmesi",
            "talepKisaAdi": "İİK.121. Maddeye Göre Yetki Verilmesi",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelIIk121YetkiVerDvo",
            "postaMasrafId": 0,
            "dosyaDurum": "H"
        },
        {
            "grupKodu": 2,
            "talepKodu": 35,
            "talepAdi": "Rehin Açığı Belgesi Hazırlanması",
            "talepKisaAdi": "Rehin Açığı Belgesi Hazırlanması",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelRehinAcigiBelgesiDvo",
            "postaMasrafId": 0,
            "dosyaDurum": "H"
        },
        {
            "grupKodu": 2,
            "talepKodu": 36,
            "talepAdi": "100. Maddeye Yarar Bilgi İstenilmesi",
            "talepKisaAdi": "100. Maddeye Yarar Bilgi İstenilmesi",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenel100MaddeYararBilgiDvo",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 2,
            "talepKodu": 37,
            "talepAdi": "Dosyadaki Avansın İadesi",
            "talepKisaAdi": "Dosyadaki Avansın İadesi",
            "talepMasrafi": 0,
            "className": "AvukatTalepDosyaAvansIadesiDvo",
            "postaMasrafId": 0,
            "dosyaDurum": "H"
        },
        {
            "grupKodu": 2,
            "talepKodu": 39,
            "talepAdi": "Haricen Tahsilat Bildirimi",
            "talepKisaAdi": "Haricen Tahsilat Bildirimi",
            "talepMasrafi": 0,
            "className": "AvukatTalepHaricenTahsilatDvo",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 2,
            "talepKodu": 42,
            "talepAdi": "Bankadan Hacizli Paranın İstenilmesi",
            "talepKisaAdi": "Bankadan Hacizli Paranın İstenilmesi",
            "talepMasrafi": 17.5,
            "className": "AvukatTalepBankadanHacizliParaIsteDVO",
            "postaMasrafId": 3585,
            "dosyaDurum": "H"
        },
        {
            "grupKodu": 2,
            "talepKodu": 46,
            "talepAdi": "Rehinin Paraya Çevrilmesi Şerhi Talebi",
            "talepKisaAdi": "Rehinin Paraya Çevrilmesi Şerhi Talebi",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelRehninParayaCevrilmesiSerhiDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        }];
    //TODO Uyap tebligatTurleriJson console a yaz ordan guncelle eger guncelleme gerekirse
    // TODO: Bunu uyaptan alamaz mıyız
    tebligat: any = {
        turler: {
            "0": {
                "masrafAdi": "E-Tebligat",
                "fiyati": 20,
                "postaMasraflariId": 0
            },
            "1": {
                "masrafAdi": "Normal Tebligat",
                "fiyati": 265,
                "postaMasraflariId": 1
            },
            "2": {
                "masrafAdi": "T.K.21/2 Şerhli(Dönüşlü)",
                "fiyati": 390,
                "postaMasraflariId": 2
            },
            "3": {
                "masrafAdi": "Hızlı Tebligat",
                "fiyati": 530,
                "postaMasraflariId": 3
            },
            "4": {
                "masrafAdi": "T.K.21/2 Şerhli Hızlı",
                "fiyati": 530,
                "postaMasraflariId": 4
            },
            "5": {
                "masrafAdi": "35. Maddeye Göre Tebligat",
                "fiyati": 265,
                "postaMasraflariId": 5
            },
            "6": {
                "masrafAdi": "35. Maddeye Göre Hızlı Tebligat",
                "fiyati": 530,
                "postaMasraflariId": 6
            },
            "7": {
                "masrafAdi": "E-Tebligat (Dönüşlü)",
                "fiyati": 28.7,
                "postaMasraflariId": 7
            },
            "8": {
                "masrafAdi": "Normal Tebligat(Dönüşlü)",
                "fiyati": 390,
                "postaMasraflariId": 8
            }
        },
        talepListesi: [{
            "grupKodu": 1,
            "talepKodu": 11,
            "talepAdi": "Bakiye Borç Muhtırasınin Tebliğe Çıkartılması",
            "talepKisaAdi": "Bakiye Borç Muhtırasınin Tebliğe Çıkartılması",
            "talepMasrafi": 0,
            "className": "AvukatTalepTebligatDosyaHesabiDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        }, {
            "grupKodu": 1,
            "talepKodu": 8,
            "talepAdi": "İcra/Ödeme Emrinin Tebliğe Çıkartılması",
            "talepKisaAdi": "İcra/Ödeme Emrinin Tebliğe Çıkartılması",
            "talepMasrafi": 0,
            "className": "AvukatTalepTebligatOdemeEmriDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        }, {
            "grupKodu": 1,
            "talepKodu": 9,
            "talepAdi": "Kıymet Takdirinin Tebliğe Çıkartılması",
            "talepKisaAdi": "Kıymet Takdirinin Tebliğe Çıkartılması",
            "talepMasrafi": 0,
            "className": "AvukatTalepTebligatKiymetTakdiriDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        }, {
            "grupKodu": 1,
            "talepKodu": 40,
            "talepAdi": "Taahhudu Kabul Muhtırası Tebliği",
            "talepKisaAdi": "Taahhudu Kabul Muhtırası Tebliği",
            "talepMasrafi": 0,
            "className": "AvukatTalepTebligatTaahhuduKabulMuhtirasiDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        }, {
            "grupKodu": 1,
            "talepKodu": 41,
            "talepAdi": "Temlik Bilgisinin Bildirilmesi",
            "talepKisaAdi": "Temlik Bilgisinin Bildirilmesi",
            "talepMasrafi": 0,
            "className": "AvukatTalepTebligatTemlikBilgisiDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        }, {
            "grupKodu": 1,
            "talepKodu": 12,
            "talepAdi": "Yenileme Emrinin Tebliğe Çıkartılması",
            "talepKisaAdi": "Yenileme Emrinin Tebliğe Çıkartılması",
            "talepMasrafi": 0,
            "className": "AvukatTalepTebligatDosyaYenilenmesiDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        }, {
            "grupKodu": 1,
            "talepKodu": 10,
            "talepAdi": "103 Davetiyesinin Tebliğe Çıkartılması",
            "talepKisaAdi": "103 Davetiyesinin Tebliğe Çıkartılması",
            "talepMasrafi": 0,
            "className": "AvukatTalepTebligat103DavetiyeDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        }],
    };
    static haciz: any = {
        talepListesi: [
            {
                "grupKodu": 0,
                "talepKodu": 0,
                "talepAdi": "Araç Haczi Talebi",
                "talepKisaAdi": "Araç Haczi Talebi",
                "talepMasrafi": 0
            },
            {
                "grupKodu": 0,
                "talepKodu": 1,
                "talepAdi": "Maaş Haczi Talebi",
                "talepKisaAdi": "Maaş Haczi Talebi",
                "talepMasrafi": 28
            },
            {
                "grupKodu": 0,
                "talepKodu": 2,
                "talepAdi": "Gayrimenkul Haczi Talebi",
                "talepKisaAdi": "Gayrimenkul Haczi Talebi",
                "talepMasrafi": 0
            },
            {
                "grupKodu": 0,
                "talepKodu": 3,
                "talepAdi": "Posta Çeki Haczi Talebi",
                "talepKisaAdi": "Posta Çeki Haczi Talebi",
                "talepMasrafi": 0.5
            },
            {
                "grupKodu": 0,
                "talepKodu": 4,
                "talepAdi": "Banka Haczi Talebi",
                "talepKisaAdi": "Banka Haczi Talebi",
                "talepMasrafi": 7.5
            },
            {
                "grupKodu": 0,
                "talepKodu": 5,
                "talepAdi": "89-1 İhbarname Talebi",
                "talepKisaAdi": "89-1 İhbarname Talebi",
                "talepMasrafi": 28
            },
            {
                "grupKodu": 0,
                "talepKodu": 6,
                "talepAdi": "SGK Mossip Haczi Talebi",
                "talepKisaAdi": "SGK Mossip Haczi Talebi",
                "talepMasrafi": 0
            },
            {
                "grupKodu": 0,
                "talepKodu": 7,
                "talepAdi": "Alacaklı Olduğu Dosya",
                "talepKisaAdi": "Alacaklı Olduğu Dosya",
                "talepMasrafi": 0
            },
            {
                "grupKodu": 0,
                "talepKodu": 23,
                "talepAdi": "Borçlunun Taşınır Mallarının Haczi için Adresinde Haciz Yapılması, Kapalı Yerlerin Çilingir ile Açılması, haczedilen Malların Muhafaza Altına Alınması",
                "talepKisaAdi": "Taşınır Haciz Talebi",
                "talepMasrafi": 0
            },
            {
                "grupKodu": 0,
                "talepKodu": 24,
                "talepAdi": "Borçlunun Taşınır Mallarının Haczedilmesi ve Muhafaza Altına Alınması için Talimat Yazılması",
                "talepKisaAdi": "Taşınır Haciz Talimatı Talebi",
                "talepMasrafi": 0
            }
        ],
        bankaHacizParams: [
            [
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "QNB FİNANSBANK ANONİM ŞİRKETİ",
                    "asilTaraf": "QNB FİNANSBANK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "159238904",
                    "asilTarafIlkKisiKurumId": "159238904",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0388002333400576"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "TÜRKİYE FİNANS KATILIM BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "TÜRKİYE FİNANS KATILIM BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "166411454",
                    "asilTarafIlkKisiKurumId": "166411454",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0068006387095226"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "ŞEKERBANK TÜRK ANONİM ŞİRKETİ",
                    "asilTaraf": "ŞEKERBANK TÜRK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "172648472",
                    "asilTarafIlkKisiKurumId": "172648472",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0801004857598667"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "VAKIF KATILIM BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "VAKIF KATILIM BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "171383708",
                    "asilTarafIlkKisiKurumId": "171383708",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0883042770000010"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "ZİRAAT KATILIM BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "ZİRAAT KATILIM BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "165057828",
                    "asilTarafIlkKisiKurumId": "165057828",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0998079311700015"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "ICBC TURKEY BANK ANONİM ŞİRKETİ",
                    "asilTaraf": "ICBC TURKEY BANK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "163266767",
                    "asilTarafIlkKisiKurumId": "163266767",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0836004772800050"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "TURKLAND BANK ANONİM ŞİRKETİ",
                    "asilTaraf": "TURKLAND BANK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "180639821",
                    "asilTarafIlkKisiKurumId": "180639821",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0389000710568940"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "TURKISH BANK ANONİM ŞİRKETİ",
                    "asilTaraf": "TURKISH BANK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "167300192",
                    "asilTarafIlkKisiKurumId": "167300192",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0871003631728905"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "ARAP TÜRK BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "ARAP TÜRK BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "163265081",
                    "asilTarafIlkKisiKurumId": "163265081",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0072000479500015"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "CİTİBANK ANONİM ŞİRKETİ",
                    "asilTaraf": "CİTİBANK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "163265142",
                    "asilTarafIlkKisiKurumId": "163265142",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0211045571800015"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "BANK MELLAT MERKEZİ TAHRAN-İSTANBUL TÜRKİYE MERKEZ ŞUBESİ",
                    "asilTaraf": "BANK MELLAT MERKEZİ TAHRAN-İSTANBUL TÜRKİYE MERKEZ ŞUBESİ",
                    "ilgiliKisiIlkKisiKurumId": "163265089",
                    "asilTarafIlkKisiKurumId": "163265089",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0140003254400014"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "TÜRKİYE SINAİ KALKINMA BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "TÜRKİYE SINAİ KALKINMA BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "163268162",
                    "asilTarafIlkKisiKurumId": "163268162",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0879003330900013"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "TÜRKİYE EMLAK KATILIM BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "TÜRKİYE EMLAK KATILIM BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "164015239",
                    "asilTarafIlkKisiKurumId": "164015239",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0879001527700040"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "GSD YATIRIM BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "GSD YATIRIM BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "163266248",
                    "asilTarafIlkKisiKurumId": "163266248",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0411008228000017"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "ADABANK ANONİM ŞİRKETİ",
                    "asilTaraf": "ADABANK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "172696893",
                    "asilTarafIlkKisiKurumId": "172696893",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0007001548100028"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "BİRLEŞİK FON BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "BİRLEŞİK FON BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "163139475",
                    "asilTarafIlkKisiKurumId": "163139475",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0292003349600019"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "BANK OF CHINA TURKEY ANONİM ŞİRKETİ",
                    "asilTaraf": "BANK OF CHINA TURKEY ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "199495597",
                    "asilTarafIlkKisiKurumId": "199495597",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0140039115300018"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "DEUTSCHE BANK ANONİM ŞİRKETİ",
                    "asilTaraf": "DEUTSCHE BANK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "163265180",
                    "asilTarafIlkKisiKurumId": "163265180",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0876004872200015"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "MUFG BANK TURKEY ANONİM ŞİRKETİ",
                    "asilTaraf": "MUFG BANK TURKEY ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "163265096",
                    "asilTarafIlkKisiKurumId": "163265096",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0140036123700018"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "RABOBANK ANONİM ŞİRKETİ",
                    "asilTaraf": "RABOBANK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "163266677",
                    "asilTarafIlkKisiKurumId": "163266677",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0734073912400011"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "HABİB BANK LİMİTED MERKEZİ PAKİSTAN-İSTANBUL TÜRKİYE MERKEZ ŞB.",
                    "asilTaraf": "HABİB BANK LİMİTED MERKEZİ PAKİSTAN-İSTANBUL TÜRKİYE MERKEZ ŞB.",
                    "ilgiliKisiIlkKisiKurumId": "163266249",
                    "asilTarafIlkKisiKurumId": "163266249",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0454001183500012"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "INTESA SANPAOLO S.P.A. İTALYA İSTANBUL MERKEZ ŞUBESİ",
                    "asilTaraf": "INTESA SANPAOLO S.P.A. İTALYA İSTANBUL MERKEZ ŞUBESİ",
                    "ilgiliKisiIlkKisiKurumId": "163266632",
                    "asilTarafIlkKisiKurumId": "163266632",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0465040810400013"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "JPMORGAN CHASE BANK NATİONAL ASSOCİATİON MERKEZİ COLUMBUS OHİO İSTANBUL TÜRKİYE ŞUBESİ",
                    "asilTaraf": "JPMORGAN CHASE BANK NATİONAL ASSOCİATİON MERKEZİ COLUMBUS OHİO İSTANBUL TÜRKİYE ŞUBESİ",
                    "ilgiliKisiIlkKisiKurumId": "163266640",
                    "asilTarafIlkKisiKurumId": "163266640",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0843000158100011"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "SOCIETE GENERALE(S.A)(PARİS)MERKEZİ FRANSA İSTANBUL TÜRKİYE MERKEZ ŞUBESİ",
                    "asilTaraf": "SOCIETE GENERALE(S.A)(PARİS)MERKEZİ FRANSA İSTANBUL TÜRKİYE MERKEZ ŞUBESİ",
                    "ilgiliKisiIlkKisiKurumId": "163266680",
                    "asilTarafIlkKisiKurumId": "163266680",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "7136729256854498"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "TÜRKİYE KALKINMA VE YATIRIM BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "TÜRKİYE KALKINMA VE YATIRIM BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "163268160",
                    "asilTarafIlkKisiKurumId": "163268160",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0879002993500013"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "İSTANBUL TAKAS VE SAKLAMA BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "İSTANBUL TAKAS VE SAKLAMA BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "163266638",
                    "asilTarafIlkKisiKurumId": "163266638",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0481002693100015"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "BANKPOZİTİF KREDİ VE KALKINMA BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "BANKPOZİTİF KREDİ VE KALKINMA BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "163265103",
                    "asilTarafIlkKisiKurumId": "163265103",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0854012611200011"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "MERRILL LYNCH YATIRIM BANK ANONİM ŞİRKETİ",
                    "asilTaraf": "MERRILL LYNCH YATIRIM BANK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "163266642",
                    "asilTarafIlkKisiKurumId": "163266642",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0830003922200010"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "STANDARD CHARTERED YATIRIM BANKASI TÜRK ANONİM ŞİRKETİ",
                    "asilTaraf": "STANDARD CHARTERED YATIRIM BANKASI TÜRK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "163266681",
                    "asilTarafIlkKisiKurumId": "163266681",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0465003220300016"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "MÜFLİS ASYA KATILIM BANKASI A.Ş.",
                    "asilTaraf": "MÜFLİS ASYA KATILIM BANKASI A.Ş.",
                    "ilgiliKisiIlkKisiKurumId": "196835301",
                    "asilTarafIlkKisiKurumId": "196835301",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "4879237429525108"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "HSBC BANK ANONİM ŞİRKETİ",
                    "asilTaraf": "HSBC BANK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "73380618",
                    "asilTarafIlkKisiKurumId": "73380618",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0621002428200197"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "TÜRKİYE GARANTİ BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "TÜRKİYE GARANTİ BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "19303042",
                    "asilTarafIlkKisiKurumId": "19303042",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0879001756600379"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "ANADOLUBANK ANONİM ŞİRKETİ",
                    "asilTaraf": "ANADOLUBANK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "143847838",
                    "asilTarafIlkKisiKurumId": "143847838",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0068011300300024"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "TÜRKİYE VAKIFLAR BANKASI TÜRK ANONİM ORTAKLIĞI",
                    "asilTaraf": "TÜRKİYE VAKIFLAR BANKASI TÜRK ANONİM ORTAKLIĞI",
                    "ilgiliKisiIlkKisiKurumId": "27320427",
                    "asilTarafIlkKisiKurumId": "27320427",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0922003497000017"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "ING BANK ANONİM ŞİRKETİ",
                    "asilTaraf": "ING BANK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "67026870",
                    "asilTarafIlkKisiKurumId": "67026870",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0876004224300365"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "BURGAN BANK ANONİM ŞİRKETİ",
                    "asilTaraf": "BURGAN BANK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "137428880",
                    "asilTarafIlkKisiKurumId": "137428880",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0140003231000116"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "DENİZBANK ANONİM ŞİRKETİ",
                    "asilTaraf": "DENİZBANK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "13102159",
                    "asilTarafIlkKisiKurumId": "13102159",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0292008449600341"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "TÜRK EKONOMİ BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "TÜRK EKONOMİ BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "58335369",
                    "asilTarafIlkKisiKurumId": "58335369",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0876004342000105"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "YAPI VE KREDİ BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "YAPI VE KREDİ BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "180704065",
                    "asilTarafIlkKisiKurumId": "180704065",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0937002089200741"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "ALTERNATİFBANK ANONİM ŞİRKETİ",
                    "asilTaraf": "ALTERNATİFBANK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "19159660",
                    "asilTarafIlkKisiKurumId": "19159660",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0060003154500048"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "AKTİF YATIRIM BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "AKTİF YATIRIM BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "155589794",
                    "asilTarafIlkKisiKurumId": "155589794",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0225013653700015"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "DİLER YATIRIM BANKASI A Ş GENEL MÜDÜRLÜĞÜ",
                    "asilTaraf": "DİLER YATIRIM BANKASI A Ş GENEL MÜDÜRLÜĞÜ",
                    "ilgiliKisiIlkKisiKurumId": "164947080",
                    "asilTarafIlkKisiKurumId": "164947080",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0297012220500011"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "PASHA YATIRIM BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "PASHA YATIRIM BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "190303981",
                    "asilTarafIlkKisiKurumId": "190303981",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0940001907300014"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "TÜRKİYE İHRACAT KREDİ BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "TÜRKİYE İHRACAT KREDİ BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "197656005",
                    "asilTarafIlkKisiKurumId": "197656005",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0879002298700034"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "ALBARAKA TÜRK KATILIM BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "ALBARAKA TÜRK KATILIM BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "76033411",
                    "asilTarafIlkKisiKurumId": "76033411",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0047000870200019"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "TÜRKİYE İŞ BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "TÜRKİYE İŞ BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "26554983",
                    "asilTarafIlkKisiKurumId": "26554983",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0481005859000909"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "KUVEYT TÜRK KATILIM BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "KUVEYT TÜRK KATILIM BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "28878548",
                    "asilTarafIlkKisiKurumId": "28878548",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0600002681400074"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "TÜRKİYE HALK BANKASI ANONİM ŞİRKETİ GENEL MÜDÜRLÜĞÜ",
                    "asilTaraf": "TÜRKİYE HALK BANKASI ANONİM ŞİRKETİ GENEL MÜDÜRLÜĞÜ",
                    "ilgiliKisiIlkKisiKurumId": "161240901",
                    "asilTarafIlkKisiKurumId": "161240901",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "1"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "AKBANK TÜRK ANONİM ŞİRKETİ",
                    "asilTaraf": "AKBANK TÜRK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "177453035",
                    "asilTarafIlkKisiKurumId": "177453035",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0015001526400497"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "ODEA BANK ANONİM ŞİRKETİ",
                    "asilTaraf": "ODEA BANK ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "133084222",
                    "asilTarafIlkKisiKurumId": "133084222",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0634042197300010"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "TÜRKİYE CUMHURİYETİ ZİRAAT BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "TÜRKİYE CUMHURİYETİ ZİRAAT BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "183262875",
                    "asilTarafIlkKisiKurumId": "183262875",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "GOLDEN GLOBAL YATIRIM BANKASI ANONİM ŞİRKETİ",
                    "asilTaraf": "GOLDEN GLOBAL YATIRIM BANKASI ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "210885830",
                    "asilTarafIlkKisiKurumId": "210885830",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0396123319100001"
                },
                {
                    "ilgiliKisiTipi": "H",
                    "ilgili": "FİBABANKA ANONİM ŞİRKETİ",
                    "asilTaraf": "FİBABANKA ANONİM ŞİRKETİ",
                    "ilgiliKisiIlkKisiKurumId": "120150101",
                    "asilTarafIlkKisiKurumId": "120150101",
                    "ilgiliKisiRolu": "Tebligat Yapılacak 3. Taraf",
                    "ilgiliKisiRolId": "122",
                    "secili": false,
                    "kisi": false,
                    "tcVatandasi": false,
                    "mersisNo": "0209000780814852"
                }
            ],
            [
                {
                    "tktId": "HTBLG0001",
                    "kod": "00001",
                    "aciklama": "Vadesiz Türk Parası Hesabı"
                },
                {
                    "tktId": "HTBLG0002",
                    "kod": "00002",
                    "aciklama": "Yatırım Hesabı Serbest Bakiye"
                },
                {
                    "tktId": "HTBLG0003",
                    "kod": "00003",
                    "aciklama": "Vadesiz Yabancı Para Hesabı"
                },
                {
                    "tktId": "HTBLG0004",
                    "kod": "00004",
                    "aciklama": "Kıymetli Maden Hesabı (Vadesiz Altın Hesabı Dahil)"
                },
                {
                    "tktId": "HTBLG0005",
                    "kod": "00005",
                    "aciklama": "B Tipi Yatırım Fonu(B Tipi Likit ve Kısa Vadeli Tahvil-Bono Fonu)"
                },
                {
                    "tktId": "HTBLG0006",
                    "kod": "00006",
                    "aciklama": "Hazine Bonosu & Devlet Tahvili(TL)"
                },
                {
                    "tktId": "HTBLG0007",
                    "kod": "00007",
                    "aciklama": "Repo"
                },
                {
                    "tktId": "HTBLG0008",
                    "kod": "00008",
                    "aciklama": "Diğer Fonlar ve A Tipi Yatırım Fonu"
                },
                {
                    "tktId": "HTBLG0009",
                    "kod": "00009",
                    "aciklama": "Vadeli Türk Parası Hesabı"
                },
                {
                    "tktId": "HTBLG0010",
                    "kod": "00010",
                    "aciklama": "Vadeli Yabancı Para Hesabı"
                },
                {
                    "tktId": "HTBLG0011",
                    "kod": "00011",
                    "aciklama": "Kıymetli Maden Hesabı (Vadeli Altın Hesabı dahil)"
                },
                {
                    "tktId": "HTBLG0012",
                    "kod": "00012",
                    "aciklama": "Anapara Koruma Amaçlı ve Anapara Garantili Fonlar"
                },
                {
                    "tktId": "HTBLG0013",
                    "kod": "00013",
                    "aciklama": "Hisse Senedi"
                },
                {
                    "tktId": "HTBLG0014",
                    "kod": "00014",
                    "aciklama": "Diğer (Hazine Bonosu & Devlet Tahvili/YP), Eurobond, VOB, Özel Sektör Tahvili v.b. menkul kıymetler)"
                },
                {
                    "tktId": "HTBLG0015",
                    "kod": "00015",
                    "aciklama": "Alış Satış Emri Olan Kıymetler (Niteliği Değişebilen Varlıklar)"
                }
            ],
            [
                {
                    "name": "Haciz Müzekkeresi",
                    "value": "MZK"
                },
                {
                    "name": "89/1 Haciz İhbarnamesi",
                    "value": "IHB"
                }
            ],
            [
                {
                    "name": "Maaş Hesabı Hariç",
                    "value": "MAAS"
                },
                {
                    "name": "Borçlu Belediye İse; *5393 Sayılı Belediye Kanununun 15.maddesi kapsamındaki Alacakları Hariç",
                    "value": "BELEDIYE"
                }
            ]
        ],
        aracHacizParams: [
            {
                "name": "Haciz",
                "value": 0
            },
            {
                "name": "Yakalama",
                "value": 3
            },
            {
                "name": "Rehinin Paraya Çevrilmesi",
                "value": 9
            },
            {
                "name": "İhtiyati Haciz",
                "value": 10
            }
        ],
        maasHacizParams: [
            {
                "name": "Çalışan Kamu",
                "value": 0
            },
            {
                "name": "Çalışan Özel",
                "value": 1
            },
            {
                "name": "Emekli Kamu",
                "value": 2
            },
            {
                "name": "Emekli Özel",
                "value": 3
            }
        ]

    };
    static baroKodlari: any[] = [{"baroKodu":"1","ilKodu":"1","baro":"ADANA"},{"baroKodu":"2","ilKodu":"2","baro":"ADIYAMAN"},{"baroKodu":"3","ilKodu":"3","baro":"AFYONKARAHİSAR"},{"baroKodu":"4","ilKodu":"4","baro":"AĞRI"},{"baroKodu":"11","ilKodu":"68","baro":"AKSARAY"},{"baroKodu":"5","ilKodu":"5","baro":"AMASYA"},{"baroKodu":"91","ilKodu":"6","baro":"ANKARA 2 NOLU"},{"baroKodu":"6","ilKodu":"6","baro":"ANKARA 1 NOLU"},{"baroKodu":"7","ilKodu":"7","baro":"ANTALYA"},{"baroKodu":"88","ilKodu":"75","baro":"ARDAHAN"},{"baroKodu":"8","ilKodu":"8","baro":"ARTVİN"},{"baroKodu":"9","ilKodu":"9","baro":"AYDIN"},{"baroKodu":"10","ilKodu":"10","baro":"BALIKESİR"},{"baroKodu":"13","ilKodu":"74","baro":"BARTIN"},{"baroKodu":"12","ilKodu":"72","baro":"BATMAN"},{"baroKodu":"90","ilKodu":"69","baro":"BAYBURT"},{"baroKodu":"72","ilKodu":"11","baro":"BİLECİK"},{"baroKodu":"80","ilKodu":"12","baro":"BİNGÖL"},{"baroKodu":"87","ilKodu":"13","baro":"BİTLİS"},{"baroKodu":"14","ilKodu":"14","baro":"BOLU"},{"baroKodu":"16","ilKodu":"15","baro":"BURDUR"},{"baroKodu":"15","ilKodu":"16","baro":"BURSA"},{"baroKodu":"17","ilKodu":"17","baro":"ÇANAKKALE"},{"baroKodu":"18","ilKodu":"18","baro":"ÇANKIRI"},{"baroKodu":"19","ilKodu":"19","baro":"ÇORUM"},{"baroKodu":"20","ilKodu":"20","baro":"DENİZLİ"},{"baroKodu":"21","ilKodu":"21","baro":"DİYARBAKIR"},{"baroKodu":"82","ilKodu":"81","baro":"DÜZCE"},{"baroKodu":"22","ilKodu":"22","baro":"EDİRNE"},{"baroKodu":"23","ilKodu":"23","baro":"ELAZIĞ"},{"baroKodu":"24","ilKodu":"24","baro":"ERZİNCAN"},{"baroKodu":"25","ilKodu":"25","baro":"ERZURUM"},{"baroKodu":"26","ilKodu":"26","baro":"ESKİŞEHİR"},{"baroKodu":"27","ilKodu":"27","baro":"GAZİANTEP"},{"baroKodu":"28","ilKodu":"28","baro":"GİRESUN"},{"baroKodu":"29","ilKodu":"29","baro":"GÜMÜŞHANE"},{"baroKodu":"86","ilKodu":"30","baro":"HAKKARİ"},{"baroKodu":"30","ilKodu":"31","baro":"HATAY"},{"baroKodu":"31","ilKodu":"76","baro":"IĞDIR"},{"baroKodu":"32","ilKodu":"32","baro":"ISPARTA"},{"baroKodu":"89","ilKodu":"34","baro":"İSTANBUL 2 NOLU"},{"baroKodu":"33","ilKodu":"34","baro":"İSTANBUL 1 NOLU"},{"baroKodu":"34","ilKodu":"35","baro":"İZMİR"},{"baroKodu":"45","ilKodu":"46","baro":"KAHRAMANMARAŞ"},{"baroKodu":"78","ilKodu":"78","baro":"KARABÜK"},{"baroKodu":"70","ilKodu":"70","baro":"KARAMAN"},{"baroKodu":"35","ilKodu":"36","baro":"KARS"},{"baroKodu":"36","ilKodu":"37","baro":"KASTAMONU"},{"baroKodu":"37","ilKodu":"38","baro":"KAYSERİ"},{"baroKodu":"71","ilKodu":"71","baro":"KIRIKKALE"},{"baroKodu":"38","ilKodu":"39","baro":"KIRKLARELİ"},{"baroKodu":"39","ilKodu":"40","baro":"KIRŞEHİR"},{"baroKodu":"79","ilKodu":"79","baro":"KİLİS"},{"baroKodu":"40","ilKodu":"41","baro":"KOCAELİ"},{"baroKodu":"41","ilKodu":"42","baro":"KONYA"},{"baroKodu":"42","ilKodu":"43","baro":"KÜTAHYA"},{"baroKodu":"43","ilKodu":"44","baro":"MALATYA"},{"baroKodu":"44","ilKodu":"45","baro":"MANİSA"},{"baroKodu":"46","ilKodu":"47","baro":"MARDİN"},{"baroKodu":"47","ilKodu":"33","baro":"MERSİN"},{"baroKodu":"48","ilKodu":"48","baro":"MUĞLA"},{"baroKodu":"49","ilKodu":"49","baro":"MUŞ"},{"baroKodu":"50","ilKodu":"50","baro":"NEVŞEHİR"},{"baroKodu":"51","ilKodu":"51","baro":"NİĞDE"},{"baroKodu":"52","ilKodu":"52","baro":"ORDU"},{"baroKodu":"81","ilKodu":"80","baro":"OSMANİYE"},{"baroKodu":"53","ilKodu":"53","baro":"RİZE"},{"baroKodu":"54","ilKodu":"54","baro":"SAKARYA"},{"baroKodu":"55","ilKodu":"55","baro":"SAMSUN"},{"baroKodu":"83","ilKodu":"56","baro":"SİİRT"},{"baroKodu":"56","ilKodu":"57","baro":"SİNOP"},{"baroKodu":"58","ilKodu":"58","baro":"SİVAS"},{"baroKodu":"63","ilKodu":"63","baro":"ŞANLIURFA"},{"baroKodu":"85","ilKodu":"73","baro":"ŞIRNAK"},{"baroKodu":"59","ilKodu":"59","baro":"TEKİRDAĞ"},{"baroKodu":"60","ilKodu":"60","baro":"TOKAT"},{"baroKodu":"61","ilKodu":"61","baro":"TRABZON"},{"baroKodu":"84","ilKodu":"62","baro":"TUNCELİ"},{"baroKodu":"64","ilKodu":"64","baro":"UŞAK"},{"baroKodu":"65","ilKodu":"65","baro":"VAN"},{"baroKodu":"77","ilKodu":"77","baro":"YALOVA"},{"baroKodu":"66","ilKodu":"66","baro":"YOZGAT"},{"baroKodu":"67","ilKodu":"67","baro":"ZONGULDAK"}];
    yargiTurleri: any[] = [{"altSistKodu": "-1", "tablo": "0901", "kod": "AĞIR CEZA MAHKEMESİ"}, {
        "altSistKodu": "-1",
        "tablo": "0921",
        "kod": "ASLİYE CEZA MAHKEMESİ"
    }, {"altSistKodu": "-1", "tablo": "7702", "kod": "Bölge Adliye Mah. Ceza Dairesi"}, {
        "altSistKodu": "-1",
        "tablo": "0929",
        "kod": "ÇOCUK AĞIR CEZA MAHKEMESİ"
    }, {"altSistKodu": "-1", "tablo": "0911", "kod": "ÇOCUK MAHKEMESİ"}, {
        "altSistKodu": "-1",
        "tablo": "0914",
        "kod": "FİKRİ VE SINAI HAKLAR CEZA MAHKEMESİ"
    }, {"altSistKodu": "-1", "tablo": "0924", "kod": "İCRA CEZA HAKİMLİĞİ"}, {
        "altSistKodu": "-1",
        "tablo": "0915",
        "kod": "İNFAZ HAKİMLİĞİ"
    }, {"altSistKodu": "-1", "tablo": "0910", "kod": "TRAFİK MAHKEMESİ"}, {
        "altSistKodu": "-1",
        "tablo": "0934",
        "kod": "YARGITAY CEZA DAİRESİ (İLK DERECE)"
    }];
    dosyaTurleri: any = {
        '0901': 'AĞIR CEZA MAHKEMESİ',
        '0921': 'ASLİYE CEZA MAHKEMESİ',
        '7702': 'Bölge Adliye Mah. Ceza Dairesi',
        '0929': 'ÇOCUK AĞIR CEZA MAHKEMESİ',
        '0911': 'ÇOCUK MAHKEMESİ',
        '0914': 'FİKRİ VE SINAI HAKLAR CEZA MAHKEMESİ',
        '0924': 'İCRA CEZA HAKİMLİĞİ',
        '0915': 'İNFAZ HAKİMLİĞİ',
        '0910': 'TRAFİK MAHKEMESİ',
        '0934': 'YARGITAY CEZA DAİRESİ (İLK DERECE)'
    };
    hacizEvrakTipleri: any[] = [
        {
            "grupKodu": 0,
            "talepKodu": 7,
            "talepAdi": "Alacaklı Olduğu Dosya",
            "talepKisaAdi": "Alacaklı Olduğu Dosya",
            "talepMasrafi": 0,
            "className": "AvukatTalepAlacakliDosyaDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 0,
            "talepKodu": 0,
            "talepAdi": "Araç Haczi Talebi",
            "talepKisaAdi": "Araç Haczi Talebi",
            "talepMasrafi": 0,
            "className": "AvukatTalepAracHacziDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 0,
            "talepKodu": 4,
            "talepAdi": "Banka Haczi Talebi",
            "talepKisaAdi": "Banka Haczi Talebi",
            "talepMasrafi": 28.7,
            "className": "AvukatTalepBankaHacziDVO",
            "postaMasrafId": 3585,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 0,
            "talepKodu": 2,
            "talepAdi": "Gayrimenkul Haczi Talebi",
            "talepKisaAdi": "Gayrimenkul Haczi Talebi",
            "talepMasrafi": 0,
            "className": "AvukatTalepGayrimenkulHacziDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 0,
            "talepKodu": 1,
            "talepAdi": "Maaş Haczi Talebi",
            "talepKisaAdi": "Maaş Haczi Talebi",
            "talepMasrafi": 390,
            "className": "AvukatTalepMaasHacziDVO",
            "postaMasrafId": 6144,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 0,
            "talepKodu": 3,
            "talepAdi": "Posta Çeki Haczi Talebi",
            "talepKisaAdi": "Posta Çeki Haczi Talebi",
            "talepMasrafi": 2.9,
            "className": "AvukatTalepPostaCekiDVO",
            "postaMasrafId": 4864,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 0,
            "talepKodu": 6,
            "talepAdi": "SGK Mosip Haczi Talebi",
            "talepKisaAdi": "SGK Mosip Haczi Talebi",
            "talepMasrafi": 0,
            "className": "AvukatTalepSgkMossipDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 0,
            "talepKodu": 23,
            "talepAdi": "Borçlunun Taşınır Mallarının Haczi için Adresinde Haciz Yapılması, Kapalı Yerlerin Çilingir ile Açılması, haczedilen Malların Muhafaza Altına Alınması",
            "talepKisaAdi": "Taşınır Haciz Talebi",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelTasinirHacziCilingirDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 0,
            "talepKodu": 24,
            "talepAdi": "Borçlunun Taşınır Mallarının Haczedilmesi ve Muhafaza Altına Alınması için Talimat Yazılması",
            "talepKisaAdi": "Taşınır Haciz Talimatı Talebi",
            "talepMasrafi": 0,
            "className": "AvukatTalepGenelHacizTalimatDVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 0,
            "talepKodu": 5,
            "talepAdi": "89-1 İhbarname Talebi",
            "talepKisaAdi": "89-1 İhbarname Talebi",
            "talepMasrafi": 0,
            "className": "AvukatTalep89_1DVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 0,
            "talepKodu": 43,
            "talepAdi": "89-2 İhbarname Talebi",
            "talepKisaAdi": "89-2 İhbarname Talebi",
            "talepMasrafi": 0,
            "className": "AvukatTalep89_2DVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        },
        {
            "grupKodu": 0,
            "talepKodu": 44,
            "talepAdi": "89-3 İhbarname Talebi",
            "talepKisaAdi": "89-3 İhbarname Talebi",
            "talepMasrafi": 0,
            "className": "AvukatTalep89_3DVO",
            "postaMasrafId": 0,
            "dosyaDurum": "A"
        }
    ];
    //EvrakTuru
    evrakTipleri: Array<EvrakTuru | any> = [
        {
            "turKodu": "ICR_ACZ_BELG_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Aciz Belgesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_ADR_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Adres Araştırması Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_AVANS_IADE_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Avans İadesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_BRC_MUH_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Bakiye Borç Muhtırası Tebliği Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_BNK_PARA_ISTE_TLBI",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Bankadan Paranın İstenilmesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_KRH_0080",
            "turTipi": "EVRTP00023",
            "turAciklama": "Adli Birimlere Bildirim",
            "aktif": "E",
            "aciklama": "Bankalarda Hesap Açilmasi İçin Talep Yazısı",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_BRC_ITRZ_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Borca İtiraz Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "1",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_BRC_EKLE_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Borçlu Eklenmesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_COCUK_TSL_SAHSI_MNSBT_TALEBI",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Çocuk Teslimi veya Çocukla Şahsi Münasebetin Tesisi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_DSY_ALACG_HCZ",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Dosya Alacağına Haciz Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "1",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_DOSYA_HSP_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Dosya Hesabı Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_DSY_ISLMDN_KLDR",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Dosyanın İşlemden Kaldırılması Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_DSY_YENLM_TLBI",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Dosyanın Yenileme Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_FAZLA_ODMNN_IADE_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Fazla Ödemenin İadesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_GNL_HCZ_BLDRM",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Genel Haciz Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_HCZ_KLDR",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Haciz Kaldırma Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "1",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_HCZ_TLMT_GON_TALB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Haciz Talimatı Gönderilmesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_HARC_IADE_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Harç İadesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_HRCN_TAHSIL_BLDRM",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Haricen Tahsil Bildirimi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_IBAN_NUMARASI_BILDIRIM_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "IBAN Numarası Bildirim Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_ODM_EMR_GOND_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "İcra/Ödeme Emri Gönderilmesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "IFL_ALCK_KAYDI_DLKCE",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "İflas Masasına Alacak Kaydı Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_GNL_0140",
            "turTipi": "EVRTP00023",
            "turAciklama": "Adli Birimlere Bildirim",
            "aktif": "H",
            "aciklama": "İhale Katılımcısı Girilmesi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "EST_VEKALETNAME",
            "turTipi": "EVRTP00038",
            "turAciklama": "Vekaletname",
            "aktif": "E",
            "aciklama": "İhaleye Katılım Kurum Temsil Evrakı",
            "ilgiliKisiOlsunMu": "H",
            "ilgiliEvrakOlsunMu": "H",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "1",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "IHL_KAT_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "İhaleye Katılım Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_IHALE_KATILM_TMNT_MEKTP",
            "turTipi": "EVRTP00023",
            "turAciklama": "Adli Birimlere Bildirim",
            "aktif": "E",
            "aciklama": "İhaleye Katılım Teminat Mektubu",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "IHALE_KATILIM_VEKALETNAMESI",
            "turTipi": "EVRTP00038",
            "turAciklama": "Vekaletname",
            "aktif": "E",
            "aciklama": "İhaleye Katılım Vekaletnamesi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_IHTYTI_HCZ_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "İhtiyati Haciz Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "1",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_IIK_150C_STS_ARZ_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "İİK. 150/c Satışa Arz Şerhi Tesis Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_YTK_BLGS_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "İİK.121.Maddeye Göre Yetki Belgesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_GNL_0350",
            "turTipi": "EVRTP00023",
            "turAciklama": "Adli Birimlere Bildirim",
            "aktif": "E",
            "aciklama": "İlam Bilgisi Evrakı",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_ISTHKK_HCZ_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "İstihkak Haczi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "KFLT_BILG_EVR",
            "turTipi": "EVRTP00023",
            "turAciklama": "Adli Birimlere Bildirim",
            "aktif": "E",
            "aciklama": "Kefalet Bilgisi Evrağı",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_KYM_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Kıymet Takdiri Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_KYM_TAK_TLMT_GON_TALB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Kıymet Takdiri Talimatı Gönderilmesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_KYMT_TAKD_VAZGEC_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Kıymet Takdirinden Vazgeçilmesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "1",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_KYM_TAK_TBL_TALB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Kıymet Takdirinin Tebliği Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_EVR_HCZ_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Kıymetli Evrak Haczi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_KRH_0020",
            "turTipi": "EVRTP00023",
            "turAciklama": "Adli Birimlere Bildirim",
            "aktif": "E",
            "aciklama": "Maaş Bilgisi Evrakı",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_MAS_HCZ_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Maaş Haczi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_MAL_BEYAN",
            "turTipi": "EVRTP00023",
            "turAciklama": "Adli Birimlere Bildirim",
            "aktif": "E",
            "aciklama": "Mal Beyanı Bildirim",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_ML_VAR_SOR_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Mal Varlığı Sorgulama Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_MHL_VSK_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Mehil Vesikası Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_HCZ_MHF",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Menkul Fiili Haciz Ve Muhafaza Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_SRG_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Mernis, Takbis, SGK, POLNET, Posta Çeki Hesabı Sorgu Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_MVD_HCZ",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Mevduat Haczi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_ODEME_YAPILMASI_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Ödeme Yapılması Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_RHN_ACG_BELG_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Rehin Açığı Belgesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "RIZ_SAT_YET_TAL",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Rızaen Satış İçin Yetki Verilmesi Talebi (İİK. 111/a Md. Göre)",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_STS_BEDEL_ODEME_TALEBI",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Satış Bedelinin Ödenmesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_STS_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Satış Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_STS_TLMT_GON_TALB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Satış Talimatı Gönderilmesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_STS_DST_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Satışın Düşürülmesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "1",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_SRK_HCZ_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Şirket Hissesi Haczi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_TAH_MUH_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Taahhadü Kabul Muhtırası Tebliği Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_THHT_EVR",
            "turTipi": "EVRTP00001",
            "turAciklama": "Dilekçe",
            "aktif": "E",
            "aciklama": "Taahhüt Evrağı",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_THL_TSL_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Tahliye ve Teslim Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_TAKIP_KESINLESTIRME_EVR",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Takibin Kesinleştirilmesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "1",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_TKP_DYNK_BLG",
            "turTipi": "EVRTP00023",
            "turAciklama": "Adli Birimlere Bildirim",
            "aktif": "E",
            "aciklama": "Takip Dayanağı Belge",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_TKY_BLG_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Takyidat Bilgisi Sorma Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_TAR_BILG_GUNC_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Taraf Bilgisinin Güncellenmesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_TSN_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Taşınır Haczi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_TSMZ_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Taşınmaz Haczi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_THR_KAR",
            "turTipi": "EVRTP00010",
            "turAciklama": "Karar",
            "aktif": "E",
            "aciklama": "Tehir-i Icra Karari",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_TMNT_IADE_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Teminatın İadesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_TMLK_BILG_GRS_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Temlik Bilgisi Girişi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_GNL_TMLK",
            "turTipi": "EVRTP00023",
            "turAciklama": "Adli Birimlere Bildirim",
            "aktif": "E",
            "aciklama": "Temlikname",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_TRFK_MEN_SRH_KALD_TALEBI",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Trafikten Men Şerhinin Kaldırılması Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_TRF_MEN_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Trafikten Men Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_UYP_ENTG_SOR_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "UYAP Entegrasyon Sorguları Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "CZM_VEKALETNAME",
            "turTipi": "EVRTP00038",
            "turAciklama": "Vekaletname",
            "aktif": "E",
            "aciklama": "Vekaletname",
            "ilgiliKisiOlsunMu": "H",
            "ilgiliEvrakOlsunMu": "H",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "1",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "CZM_VEKILLIKTEN_AZIL",
            "turTipi": "EVRTP00001",
            "turAciklama": "Dilekçe",
            "aktif": "E",
            "aciklama": "Vekillikten Azil Dilekçesi",
            "ilgiliKisiOlsunMu": "E",
            "ilgiliEvrakOlsunMu": "H",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "1",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "CZM_VEKILLIKTEN_CEKILME",
            "turTipi": "EVRTP00001",
            "turAciklama": "Dilekçe",
            "aktif": "E",
            "aciklama": "Vekillikten Çekilme Dilekçesi",
            "ilgiliKisiOlsunMu": "E",
            "ilgiliEvrakOlsunMu": "H",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "1",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_VRST_YTK_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Veraset Yetki Belgesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_YED_DEG_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Yediemin Değişikliği Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_GNL_0525",
            "turTipi": "EVRTP00023",
            "turAciklama": "Adli Birimlere Bildirim",
            "aktif": "E",
            "aciklama": "Yeni Hesap Bilgisi için iletilen Evrak",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_YTK_BLG",
            "turTipi": "EVRTP00021",
            "turAciklama": "Tarafların Talep Ettikleri Yazılar",
            "aktif": "E",
            "aciklama": "Yetki Belgesi",
            "ilgiliKisiOlsunMu": "E",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "2",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "H",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_YTK_DOS_GOND_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "Yetkili İcra Dairesine Dosyanın Gönderilmesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_BLG_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "100.Madde Bilgi Toplanması Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_DVT_GON_TALB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "103 Davetiye Gönderilmesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_21/2_TBL_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "21/2 Maddeye Göre Tebliğ Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_TBL_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "35.Maddeye Göre Tebliğ Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_FERAGAT_7420_3_TLB",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "7420 Sayılı Kanunun Geçici 3.Maddesi Kapsamında Feragat Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_89_1_HCZ_IHBR_CVB",
            "turTipi": "EVRTP00022",
            "turAciklama": "İcra Dairesi Genel Yazı",
            "aktif": "E",
            "aciklama": "89/1 Haciz İhbarnamesi Cevabı",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_89_1_HCZ_IHBR_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "89/1 Haciz İhbarnamesi Gönderilmesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_89_2_HCZ_IHBR_CVB",
            "turTipi": "EVRTP00022",
            "turAciklama": "İcra Dairesi Genel Yazı",
            "aktif": "E",
            "aciklama": "89/2 Haciz İhbarnamesi Cevabı",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_89_2_HCZ_IHBR_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "89/2 Haciz İhbarnamesi Gönderilmesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_89_3_HCZ_IHBR_CVB",
            "turTipi": "EVRTP00022",
            "turAciklama": "İcra Dairesi Genel Yazı",
            "aktif": "E",
            "aciklama": "89/3 Haciz İhbarnamesi Cevabı",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        },
        {
            "turKodu": "ICR_89_3_HCZ_IHBR_TLP",
            "turTipi": "EVRTP00083",
            "turAciklama": "Talep",
            "aktif": "E",
            "aciklama": "89/3 Haciz İhbarnamesi Gönderilmesi Talebi",
            "ilgiliKisiOlsunMu": "F",
            "ilgiliEvrakOlsunMu": "F",
            "islemTipi": "1",
            "dosyaTipi": "0",
            "statusYeni": "false",
            "diskeKaydedilebilir": "E",
            "diskeKaydedilebilirOnayOncesi": "E",
            "imzaGerekli": "E",
            "indekslensin": "false",
            "yuksekOnemliIs": "0",
            "onaySonrasiIsOlusturusun": "1",
            "tebligataCiksinmi": "0",
            "yuksekMahkemeyeIsDussun": "0",
            "onayOncesiDagitimDuzenlenebilir": "E",
            "fizikiGonderilebilir": "H",
            "disUygulamaAktif": "E",
            "ekImzasiZorunlumu": "H",
            "ekListesiDegistirilebilir": "E",
            "evrakListesindeGorunmesin": "H"
        }
    ];
    iller: any[] = [{
        "il": "0",
        "ad": "Lütfen Seçiniz",
        "kodAciklamaCiksin": "false",
        "bolgeId": "0",
        "buyuksehir": "false"
    },
        {"il": "34", "ad": "İSTANBUL", "kodAciklamaCiksin": "false", "bolgeId": "0", "buyuksehir": "false"}, {
            "il": "6",
            "ad": "ANKARA",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {"il": "35", "ad": "İZMİR", "kodAciklamaCiksin": "false", "bolgeId": "0", "buyuksehir": "false"}, {
            "il": "1",
            "ad": "ADANA",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "2",
            "ad": "ADIYAMAN",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "3",
            "ad": "AFYONKARAHİSAR",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {"il": "4", "ad": "AĞRI", "kodAciklamaCiksin": "false", "bolgeId": "0", "buyuksehir": "false"}, {
            "il": "5",
            "ad": "AMASYA",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "7",
            "ad": "ANTALYA",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {"il": "8", "ad": "ARTVİN", "kodAciklamaCiksin": "false", "bolgeId": "0", "buyuksehir": "false"}, {
            "il": "9",
            "ad": "AYDIN",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "10",
            "ad": "BALIKESİR",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "11",
            "ad": "BİLECİK",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "12",
            "ad": "BİNGÖL",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "13",
            "ad": "BİTLİS",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {"il": "14", "ad": "BOLU", "kodAciklamaCiksin": "false", "bolgeId": "0", "buyuksehir": "false"}, {
            "il": "15",
            "ad": "BURDUR",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "16",
            "ad": "BURSA",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "17",
            "ad": "ÇANAKKALE",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "18",
            "ad": "ÇANKIRI",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "19",
            "ad": "ÇORUM",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "20",
            "ad": "DENİZLİ",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "21",
            "ad": "DİYARBAKIR",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "22",
            "ad": "EDİRNE",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "23",
            "ad": "ELAZIĞ",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "24",
            "ad": "ERZİNCAN",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "25",
            "ad": "ERZURUM",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "26",
            "ad": "ESKİŞEHİR",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "27",
            "ad": "GAZİANTEP",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "28",
            "ad": "GİRESUN",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "29",
            "ad": "GÜMÜŞHANE",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "30",
            "ad": "HAKKARİ",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "31",
            "ad": "HATAY",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "32",
            "ad": "ISPARTA",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "33",
            "ad": "MERSİN",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {"il": "36", "ad": "KARS", "kodAciklamaCiksin": "false", "bolgeId": "0", "buyuksehir": "false"}, {
            "il": "37",
            "ad": "KASTAMONU",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "38",
            "ad": "KAYSERİ",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "39",
            "ad": "KIRKLARELİ",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "40",
            "ad": "KIRŞEHİR",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "41",
            "ad": "KOCAELİ",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "42",
            "ad": "KONYA",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "43",
            "ad": "KÜTAHYA",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "44",
            "ad": "MALATYA",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "45",
            "ad": "MANİSA",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "46",
            "ad": "KAHRAMANMARAŞ",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "47",
            "ad": "MARDİN",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "48",
            "ad": "MUĞLA",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {"il": "49", "ad": "MUŞ", "kodAciklamaCiksin": "false", "bolgeId": "0", "buyuksehir": "false"}, {
            "il": "50",
            "ad": "NEVŞEHİR",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "51",
            "ad": "NİĞDE",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {"il": "52", "ad": "ORDU", "kodAciklamaCiksin": "false", "bolgeId": "0", "buyuksehir": "false"}, {
            "il": "53",
            "ad": "RİZE",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "54",
            "ad": "SAKARYA",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "55",
            "ad": "SAMSUN",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "56",
            "ad": "SİİRT",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "57",
            "ad": "SİNOP",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "58",
            "ad": "SİVAS",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "59",
            "ad": "TEKİRDAĞ",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "60",
            "ad": "TOKAT",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "61",
            "ad": "TRABZON",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "62",
            "ad": "TUNCELİ",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "63",
            "ad": "ŞANLIURFA",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {"il": "64", "ad": "UŞAK", "kodAciklamaCiksin": "false", "bolgeId": "0", "buyuksehir": "false"}, {
            "il": "65",
            "ad": "VAN",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "66",
            "ad": "YOZGAT",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "67",
            "ad": "ZONGULDAK",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "68",
            "ad": "AKSARAY",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "69",
            "ad": "BAYBURT",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "70",
            "ad": "KARAMAN",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "71",
            "ad": "KIRIKKALE",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "72",
            "ad": "BATMAN",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "73",
            "ad": "ŞIRNAK",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "74",
            "ad": "BARTIN",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "75",
            "ad": "ARDAHAN",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "76",
            "ad": "IĞDIR",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "77",
            "ad": "YALOVA",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "78",
            "ad": "KARABÜK",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "79",
            "ad": "KİLİS",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {
            "il": "80",
            "ad": "OSMANİYE",
            "kodAciklamaCiksin": "false",
            "bolgeId": "0",
            "buyuksehir": "false"
        }, {"il": "81", "ad": "DÜZCE", "kodAciklamaCiksin": "false", "bolgeId": "0", "buyuksehir": "false"}
    ];
    takipMahiyetleri: any[] = [{
        "mahiyetId": "1307",
        "kod": "BLGSZ",
        "takipSekliKod": "7",
        "mahiyetAdi": "Belgesiz",
        "gecerlimi": "E"
    }, {
        "mahiyetId": "1107",
        "kod": "COCUK",
        "takipSekliKod": "7",
        "mahiyetAdi": "Cocuk Teslimi",
        "gecerlimi": "E"
    }, {
        "mahiyetId": "6007",
        "kod": "DGZ",
        "takipSekliKod": "7",
        "mahiyetAdi": "Doğal Gaz",
        "gecerlimi": "E"
    }, {
        "mahiyetId": "5007",
        "kod": "ELKT",
        "takipSekliKod": "7",
        "mahiyetAdi": "Elektrik",
        "gecerlimi": "E"
    }, {
        "mahiyetId": "3007",
        "kod": "INTTV",
        "takipSekliKod": "7",
        "mahiyetAdi": "İnternet/Tv",
        "gecerlimi": "E"
    }, {
        "mahiyetId": "7007",
        "kod": "KRD",
        "takipSekliKod": "7",
        "mahiyetAdi": "Kredi Kartı",
        "gecerlimi": "E"
    }, {
        "mahiyetId": "8008",
        "kod": "KRDSOZ",
        "takipSekliKod": "7",
        "mahiyetAdi": "Kredi Sözleşmesi",
        "gecerlimi": "E"
    }, {
        "mahiyetId": "9009",
        "kod": "NFK",
        "takipSekliKod": "7",
        "mahiyetAdi": "Nafaka",
        "gecerlimi": "E"
    }, {
        "mahiyetId": "1407",
        "kod": "SOZL",
        "takipSekliKod": "7",
        "mahiyetAdi": "Sözleşme/Protokol",
        "gecerlimi": "E"
    }, {
        "mahiyetId": "4007",
        "kod": "SU",
        "takipSekliKod": "7",
        "mahiyetAdi": "Su",
        "gecerlimi": "E"
    }, {
        "mahiyetId": "2007",
        "kod": "CEPTEL",
        "takipSekliKod": "7",
        "mahiyetAdi": "Telefon(Cep)",
        "gecerlimi": "E"
    }, {
        "mahiyetId": "1007",
        "kod": "SBTTEL",
        "takipSekliKod": "7",
        "mahiyetAdi": "Telefon(Sabit)",
        "gecerlimi": "E"
    }, {"mahiyetId": "1207", "kod": "HKM", "takipSekliKod": "7", "mahiyetAdi": "Tük.Hakem Heyeti", "gecerlimi": "E"}];
    mtsTakipMahiyetleri: any[] = [{
        "mahiyetId": 1007,
        "kod": "SBTTEL",
        "takipSekliKod": 7,
        "mahiyetAdi": "Telefon(Sabit)",
        "gecerlimi": "E",
        "zorunlu": false,
        "degistirilemez": false
    }, {
        "mahiyetId": 2007,
        "kod": "CEPTEL",
        "takipSekliKod": 7,
        "mahiyetAdi": "Telefon(Cep)",
        "gecerlimi": "E",
        "zorunlu": false,
        "degistirilemez": false
    }, {
        "mahiyetId": 4007,
        "kod": "SU",
        "takipSekliKod": 7,
        "mahiyetAdi": "Su",
        "gecerlimi": "E",
        "zorunlu": false,
        "degistirilemez": false
    }, {
        "mahiyetId": 3007,
        "kod": "INTTV",
        "takipSekliKod": 7,
        "mahiyetAdi": "İnternet/Tv",
        "gecerlimi": "E",
        "zorunlu": false,
        "degistirilemez": false
    }, {
        "mahiyetId": 5007,
        "kod": "ELKT",
        "takipSekliKod": 7,
        "mahiyetAdi": "Elektrik",
        "gecerlimi": "E",
        "zorunlu": false,
        "degistirilemez": false
    }, {
        "mahiyetId": 6007,
        "kod": "DGZ",
        "takipSekliKod": 7,
        "mahiyetAdi": "Doğal Gaz",
        "gecerlimi": "E",
        "zorunlu": false,
        "degistirilemez": false
    }, {
        "mahiyetId": 1407,
        "kod": "SOZL",
        "takipSekliKod": 7,
        "mahiyetAdi": "Diğer",
        "gecerlimi": "E",
        "zorunlu": false,
        "degistirilemez": false
    }];
    mtsDosyaKriterleri: Array<{
        kod: string,
        mahiyetAdi: string,
        zorunlu: boolean,
        degistirilemez: boolean
    }> = [
        {
            "kod": "bk",
            "mahiyetAdi": "B.K. 100.Madde",
            "zorunlu": true,
            "degistirilemez": true
        },
        {
            "kod": "vkdv",
            "mahiyetAdi": "Vekalet Ücretine KDV",
            "zorunlu": false,
            "degistirilemez": false
        },
        {
            "kod": "bsmv",
            "mahiyetAdi": "BSMV",
            "zorunlu": false,
            "degistirilemez": false
        },
        {
            "kod": "kkdf",
            "mahiyetAdi": "KKDF",
            "zorunlu": false,
            "degistirilemez": false
        },
        {
            "kod": "kdv",
            "mahiyetAdi": "KDV",
            "zorunlu": false,
            "degistirilemez": false
        },
        {
            "kod": "oiv",
            "mahiyetAdi": "Özel İletişim Ver.(%25)",
            "zorunlu": false,
            "degistirilemez": false
        }
    ];
    mtsIcraSebepList: any[] = [
        {
            "name": "TEBLIG_IMKANSIZLIGI",
            "id": "0",
            "kapatmaTuru": "1",
            "aciklama": "Tebliğ İmkansızlığı"
        },
        {
            "name": "SURESINDE_TAM_ODEME_YAPMAMA",
            "id": "1",
            "kapatmaTuru": "1",
            "aciklama": "Borcun Tamamının Ödenmemesi"
        },
        {
            "name": "SURESINDE_KISMEN_ODEME_YAPMA",
            "id": "2",
            "kapatmaTuru": "1",
            "aciklama": "Borcun Kısmen Ödenmesi"
        },
        {
            "name": "YETKIYE_ITIRAZIN_KALDIRILMASI",
            "id": "9",
            "kapatmaTuru": "1",
            "aciklama": "Yetkiye İtirazının Kaldırılması"
        }];
    ilamKurumTurleri: any[] =
        [
            {name: 'Hukuk Mahkemesi', value: "0", yargiTuru: 1},
            {name: 'Ceza Mahkemesi', value: "1", yargiTuru: 0},
            {name: 'İdare Mahkemesi', value: "2", yargiTuru: 6},
            {name: 'Noter', value: "3"},
            {name: 'Hakem Kararı', value: "4"},
            {name: 'Arabuluculuk', value: "5"},
            {name: 'Diğer', value: "6"},
            {name: 'Bölge Adliye Mahkemesi', value: "7"}
        ];

}